"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("../../components/Tooltip");
var globals = __importStar(require("../_globals"));
var tooltip = Tooltip_1.Tooltip.getInstance();
jQuery(globals.root).on("click", "[data-tooltip]", function () {
    tooltip.show(this.getAttribute("data-tooltip"), this);
});
